import React from "react";
import Typewriter from "typewriter-effect";
import { Leaf, Recycle, PiggyBank, Heart } from "lucide-react";

const values = [
  {
    id: 1,
    title: "Eco-Friendly",
    description: "Our products are made from natural jute fibers that are biodegradable and sustainable.",
    icon: Leaf,
  },
  {
    id: 2,
    title: "Handcrafted",
    description: "Each item is carefully handwoven by skilled artisans using traditional techniques.",
    icon: Heart,
  },
  {
    id: 3,
    title: "Durable",
    description: "Jute products are known for their strength and longevity, providing excellent value.",
    icon: PiggyBank,
  },
  {
    id: 4,
    title: "Renewable",
    description: "Jute is a renewable resource that grows quickly with minimal environmental impact.",
    icon: Recycle,
  },
];

const ValueProposition = () => {
  return (
    <section className="section-padding bg-jute-100">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="heading-md mb-3">Why Choose Jute</h2>
          <p className="max-w-2xl mx-auto text-muted-foreground">
            Sustainable, beautiful, and practical - discover the many benefits of our jute products.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value) => (
            <div
              key={value.id}
              className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <div className="mb-4 bg-jute-50 w-12 h-12 rounded-full flex items-center justify-center text-jute-600">
                <value.icon size={24} />
              </div>
              <h3 className="text-xl font-medium mb-2">{value.title}</h3>
              <p className="text-muted-foreground min-h-[4.5rem]">
                <Typewriter
                  options={{ loop: true, delay: 30, deleteSpeed: 20 }}
                  onInit={(typewriter) => {
                    typewriter
                      .typeString(value.description)
                      .pauseFor(2000)       // Wait 2 seconds at the end
                      .deleteAll()
                      .start();
                  }}
                />
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
